
const Footer = () => {
  return (
    <footer>
        <p>Copyright © 2023 Aliquam Studios. All rights reserved.</p>
    </footer>
  )
}

export default Footer